import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { getData } from "../utils/requests";
import dashboardImage from "../assets/BG_Congragulation.jpg";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";
import medal from "../assets/medal.svg";
import home from "../assets/home.svg";
import siemens_logo from "../assets/siemens_logo.svg";
import replay from "../assets/replay.svg";

const Dashboard = () => {
  const [user, setUser] = useState({});
  const [leaderboard, setLeaderboard] = useState([]);
  const [winningmsg, setWinningMsg] = useState("");
  const navigate = useNavigate();

  const playQuizAgain = () => {
    console.log("came to play again mode");
    localStorage.removeItem("quizQuestions");
    navigate("/quiz");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { user, participants } = await getData("quiz/leaderboard");
        setUser(user);
        setLeaderboard(participants);
        if (user?.answered_correct == 5) {
          setWinningMsg("Congratulations you answered all questions right!");
        } else {
          setWinningMsg("Better luck next time!");
        }
      } catch (error) {
        console.error("Failed to fetch leaderboard:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(${dashboardImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Container fluid>
        <Row className="justify-content-between align-items-center">
          <Col>
            {/*<h2
              style={{ fontSize: "2.9rem", fontWeight: "bold", color: "#fff" }}
            >
              COACT
            </h2>*/}
             <img
              src={siemens_logo}
              alt="logo"
              style={{ width: "150px", height: "80px" }}
            /> 
          </Col>
          <Col xs="auto">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: "#00d8ff",
                cursor: "pointer",
              }}
              onClick={() => navigate("/")}
            >
              <img
                src={home}
                alt="Medal Icon"
                style={{ fontSize: "1.2rem", marginRight: "5px" }}
              />
              <span style={{ fontSize: "1.2rem", color: "#00FFB9" }}>Home</span>
            </div>
          </Col>
          <img
            src={replay}
            alt="replay Icon"
            style={{ width: "70px", height: "70px", cursor: "pointer" }}
            onClick={() => playQuizAgain()}
          />
        </Row>

        <Row className="justify-content-center text-center mt-4">
          {user?.answered_correct === 5 && (
            <Col xs={12}>
              <img
                src={medal}
                alt="Medal Icon"
                style={{ width: "80px", height: "80px" }}
              />
            </Col>
          )}
          <Col xs={12}>
            <h3
              style={{
                color: "#00FFB9",
                fontWeight: "bold",
                fontSize: "1.5rem",
                marginTop: "10px",
              }}
            >
              {winningmsg}{" "}
              {/* <button
                onClick={() => playQuizAgain()}
                style={{
                  backgroundImage:
                    "linear-gradient(to right, #00E6DC, #00FFB9)",
                  border: "2px solid #00d8ff",
                  borderRadius: "8px",
                  padding: "3px 5px",
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                }}
              >
                Play Again
              </button> */}
            </h3>
          </Col>
        </Row>

        <Row className="align-items-center justify-content-center mt-4">
          {/* Circular Score Display */}
          <Col xs={12} md={5} className="d-flex justify-content-center">
            <div className="position-relative">
              <div className="outer-circle">
                <div className="middle-circle">
                  <div className="inner-circle">
                    <p className="score-text">
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "1.5rem",
                        }}
                      >
                        You got
                      </span>{" "}
                      <br />
                      <strong>
                        {" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            fontSize: "2.4rem",
                          }}
                        >
                          {" "}
                          {user?.answered_correct || 0}/5{" "}
                        </span>
                      </strong>
                      <br />
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "1.5rem",
                        }}
                      >
                        correct
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* Leaderboard Table */}

          <Col xs={12} md={6} className="d-flex flex-column align-items-center" style={{ marginTop: "-70px" }}>
            <h5 className="text-center" style={{ color: "#00FFB9" }}>
              LEADERBOARD
            </h5>
            <table className="leaderboard-table">
              <thead style={{ color: "#00FFB9" }}>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Time</th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody style={{ color: "#00E6DC" }}>
                {leaderboard?.slice(0, 5).map((user, index) => (
                  <tr key={user.id}>
                    <td>{index + 1}</td>
                    <td>
                      {user.name.charAt(0).toUpperCase() + user.name.slice(1)}
                    </td>
                    <td>{user.time_taken}</td>
                    <td>{user.answered_correct || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Dashboard;
